import { render, staticRenderFns } from "./script_chapter.vue?vue&type=template&id=41bcc422&scoped=true"
import script from "./script_chapter.vue?vue&type=script&lang=js"
export * from "./script_chapter.vue?vue&type=script&lang=js"
import style0 from "./script_chapter.vue?vue&type=style&index=0&id=41bcc422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bcc422",
  null
  
)

export default component.exports